module.exports = __webpack_public_path__ + "static/img/GR.e7f9a0de.png";